module.exports = __webpack_public_path__ + "static/3_King-01e2eebf0bca86d7ddc3243a05df871f.png";